import { render, staticRenderFns } from "./showTaskCard.vue?vue&type=template&id=169fd312&scoped=true&"
import script from "./showTaskCard.vue?vue&type=script&lang=js&"
export * from "./showTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./showTaskCard.vue?vue&type=style&index=0&id=169fd312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169fd312",
  null
  
)

export default component.exports